export default "__VITE_ASSET__CS03zFFr__"